module.exports = __webpack_public_path__ + "static/media/iP-Phone.a3591d53.png";